import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=5d5532ee&scoped=true&"
import script from "./pay.js?vue&type=script&lang=js&"
export * from "./pay.js?vue&type=script&lang=js&"
import style0 from "./pay.vue?vue&type=style&index=0&id=5d5532ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5532ee",
  null
  
)

export default component.exports